// For google maps api
import { Controller } from "@hotwired/stimulus";
import * as myMap from "./maps";
import { stopLinkBeingFollowed, resolveMapTypeId, layerManager } from "./maps";
import { OTHER_AAZ_STYLE, EDITED_AAZ_STYLE } from "./style_defaults";

// polygon is stored in global variable (this.polygon) and the dom as a polyPath (this.inputTarget.value)
// also stored are the drawingManager (this.drawingManager)
// lessons learned:
// add the eventlisteners in this file (and use _this) to avoid scope problems with 'this'
// this only draws polygons, not circles
export default class extends Controller {
  static targets = ['map', 'aaz', 'input', 'toggleRestrictedAirspace', 'toggleCraneZones', 'safeguardingVisible', 'otherAaz', 'polygonControls']

  // Use centralized toggle method
  async toggleLayer(event) {
    await layerManager.handleToggleLayer(event);
  }

  polygonChanged(polygon_listener) {
    // console.log('aaz polygon changed');
    this.polygon = polygon_listener;
    let path = google.maps.geometry.encoding.encodePath(polygon_listener.getPath());
    this.inputTarget.value = path;
  }

  addListenersToPolygon(polygon){
    var _this = this
    google.maps.event.addListener(polygon.getPath(), 'set_at', function(event){
      _this.polygonChanged(polygon)
    });

    google.maps.event.addListener(polygon.getPath(), 'insert_at', function(event){
      _this.polygonChanged(polygon)
    });

    google.maps.event.addListener(polygon.getPath(), 'remove_at', function(event){
      _this.polygonChanged(polygon)
    });

    google.maps.event.addListener(polygon.getPath(), 'dragend', function(event){
      _this.polygonChanged(polygon)
    });
  }

  async resetMap(event) {
    stopLinkBeingFollowed(event);
    let mapCentreLat = this.data.get("mapCentreLat");
    let mapCentreLon = this.data.get("mapCentreLon");
    const zoom = parseInt(this.data.get("defaultZoom")) || 12;
    const mapType = resolveMapTypeId(this.data.get("defaultMapType"));
    this.map.setOptions(myMap.defaultMapOptions(mapCentreLat, mapCentreLon, zoom, mapType));
    await layerManager.resetAllLayerDefaults(this.element, 'aaz-map-edit');
  }

  deletePolygon(event) {
    // console.log('aaz delete polygon');
    if (event) { stopLinkBeingFollowed(event); }
    if (this.polygon) { // check polygon is present before deleting
      this.polygon.setMap(null);
      this.polygon = null;
      this.inputTarget.value = ''; // save to dom
      myMap.showDrawingManager(this.drawingManager)
      this.hidePolygonControls();
    }
  }

  showPolygonControls() {
    if (this.hasPolygonControlsTarget) {
      this.polygonControlsTarget.style.display = 'block';
    }
  }

  hidePolygonControls() {
    if (this.hasPolygonControlsTarget) {
      this.polygonControlsTarget.style.display = 'none';
    }
  }

  polygonComplete(polygon_listener) {
    // console.log('aaz polygon complete');
    let path = google.maps.geometry.encoding.encodePath(polygon_listener.getPath());
    this.inputTarget.value = path;
    this.polygon = polygon_listener;
    this.polygon.setOptions(EDITED_AAZ_STYLE);
    myMap.hideDrawingManager(this.drawingManager);
    this.addListenersToPolygon(this.polygon); // allow editing
    this.showPolygonControls();
  }

  async connect() {
    // console.log('aaz map edit controller');

    let mapCentreLat = this.data.get("mapCentreLat");
    let mapCentreLon = this.data.get("mapCentreLon");
    const zoom = parseInt(this.data.get("defaultZoom")) || 12;
    const mapType = resolveMapTypeId(this.data.get("defaultMapType"));

    let map = new google.maps.Map(this.mapTarget, myMap.defaultMapOptions(mapCentreLat, mapCentreLon, zoom, mapType));
    this.map = map;
    await layerManager.initializeLayers(this.map, this);

    myMap.addGetBoundsFunction();

    let drawingManager = myMap.setUpAazDrawingManager(this.map);

    this.polygon = null;
    this.drawingManager = drawingManager;

    // Draw other AAZs in yellow as static background reference
    this.otherAazPolygons = [];  // Track other AAZ polygons
    if (this.hasOtherAazTarget) {
      for (let otherAazElement of this.otherAazTargets) {
        let polyPath = otherAazElement.dataset.polygon;
        let otherPolygon = myMap.drawPolygonFromPath(this.map, polyPath);
        otherPolygon.setOptions(OTHER_AAZ_STYLE);
        this.otherAazPolygons.push(otherPolygon);
      }
    }

    // Draw the current/edited AAZ
    let polyPath = this.inputTarget.value;

    if (polyPath) { // polygon already present
      myMap.hideDrawingManager(drawingManager); // hide drawing manager if a polygon is already present
      this.polygon = myMap.drawPolygonFromPath(this.map, polyPath);
      this.polygon.setOptions(EDITED_AAZ_STYLE); // editable
      this.addListenersToPolygon(this.polygon);
      this.showPolygonControls();
    }

    var _this = this;
    google.maps.event.addListener(drawingManager, 'polygoncomplete', function(polygon_listener){
      _this.polygonComplete(polygon_listener);
    });

  }

}
